'use client';

import { createContext, useContext, useLayoutEffect, type Dispatch, type SetStateAction } from 'react';

type MagazineTrackContainerName = 'Home' | 'Author Profile' | 'Article' | 'Category';

type MagazineTrackMetaProps = {
  container: MagazineTrackContainerName;
  type?: string;
  title?: string;
  provider?: string;
};

const MagazineTrackMetaContext = createContext<Dispatch<SetStateAction<Partial<MagazineTrackMetaProps>>> | null>(null);

function MagazineTrackMeta({ container, type, title, provider }: MagazineTrackMetaProps) {
  const setMeta = useContext(MagazineTrackMetaContext);

  useLayoutEffect(() => {
    if (!setMeta) {
      return;
    }

    setMeta({ container, type, title, provider });

    return () => {
      setMeta({});
    };
  }, [container, provider, setMeta, title, type]);

  return null;
}

export { MagazineTrackMeta, MagazineTrackMetaContext, type MagazineTrackContainerName, type MagazineTrackMetaProps };
